import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import LoadingButton from 'components/loading-button'
import Collapse from '@material-ui/core/Collapse'
import FormHelperText from '@material-ui/core/FormHelperText'
import Grid from '@material-ui/core/Grid'
import Link from '@material-ui/core/Link'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { useLazyQuery } from '@apollo/client'
import gql from 'graphql-tag'

export const VALID_REGISTRATION_CODE = gql`
  query ProgramRegistrationCodeValid($id: ID!, $registrationCode: String!) {
    programRegistrationCodeValid(id: $id, registrationCode: $registrationCode) {
      success
      message
    }
  }
`

const useStyles = makeStyles(theme => ({
  grayBox: {
    background: '#EBEBEB',
    borderRadius: '5px',
    padding: '16px',
    textAlign: 'center',
  },
  card: {
    border: '1px solid #DBDCDD',
    boxSizing: 'border-box',
    boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.12)',
    borderRadius: '10px',
  },
  regularFont: {
    fontFamily: 'PlusJakarta Text',
  },
}))

const RegisterWithAccessCode = ({
  viewAccessCodeRequired,
  registerUrl,
  programId,
  codeValidationQuery = VALID_REGISTRATION_CODE,
}) => {
  const [showForm, setShowForm] = useState(false)
  const [registrationCode, setRegistrationCode] = useState('')
  const [error, setError] = useState(false)
  const verifyCode = ({ programRegistrationCodeValid }) => {
    if (programRegistrationCodeValid.success) {
      const searchParams = new URLSearchParams({ registrationCode })
      window.location.href = `${registerUrl}?${searchParams}`
    } else {
      setError(true)
    }
  }
  const [validRegistrationCode, { loading }] = useLazyQuery(
    codeValidationQuery,
    { onCompleted: verifyCode },
  )

  const onInput = e => {
    setError(false)
    setRegistrationCode(e.target.value)
  }

  const classes = useStyles()
  return (
    <div className={classes.grayBox}>
      <Box mb={2}>
        <Typography
          variant="h6"
          color="textPrimary"
          className={classes.regularFont}
        >
          Access Code Required
        </Typography>
        <Typography variant="h3" color="primary">
          <Link style={{ fontSize: '16px' }} onClick={viewAccessCodeRequired}>
            (What's this?)
          </Link>
        </Typography>
      </Box>
      <Button
        onClick={() => setShowForm(state => !state)}
        variant="contained"
        color="primary"
        fullWidth
      >
        Register with Access Code
      </Button>
      <Collapse in={showForm}>
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={8}>
              <TextField
                variant="outlined"
                style={{ background: '#ffffff' }}
                InputProps={{
                  placeholder: 'Access Code',
                }}
                inputProps={{ style: { padding: '14.5px' } }}
                value={registrationCode}
                onChange={onInput}
              />
              {error ? (
                <FormHelperText error>
                  Access code does not match
                </FormHelperText>
              ) : (
                <div style={{ height: '27px' }} />
              )}
            </Grid>
            <Grid item xs={4}>
              <LoadingButton
                variant="contained"
                color="primary"
                fullWidth
                loading={loading}
                onClick={() => {
                  validRegistrationCode({
                    variables: { id: programId, registrationCode },
                  })
                }}
              >
                Verify
              </LoadingButton>
            </Grid>
          </Grid>
        </Box>
      </Collapse>
    </div>
  )
}

export default RegisterWithAccessCode
